import { render, staticRenderFns } from "./editProductAllInfoModal.vue?vue&type=template&id=2bb17e51"
import script from "./editProductAllInfoModal.vue?vue&type=script&lang=js"
export * from "./editProductAllInfoModal.vue?vue&type=script&lang=js"
import style0 from "./editProductAllInfoModal.vue?vue&type=style&index=0&id=2bb17e51&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports